<template>
  <layout :show-profile="true">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12">

      <div class="flex flex-col">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 ">




          <fieldset class="mt-0 max-w-sm mx-auto select-none">
            <div class="space-y-4">

              <!-- Page Header: start -->
              <div class="md:flex md:items-center md:justify-between">

                <div class="flex-1 min-w-0">
                  <h2 class="text-2xl font-light leading-7 text-gray-900 sm:text-2xl sm:leading-9 sm:truncate">
                    Copy Quick Check
                  </h2>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">

                </div>
              </div>
              <!-- Page Header: end -->

              <form @submit.prevent="submit" novalidate>

                <div>

                  <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="px-4 py-5 bg-white sm:p-6">
                      <div class="grid grid-cols-3 gap-6">
                        <div class="col-span-6 sm:col-span-4">
                          <label for="text" class="block text-sm font-medium leading-5 text-gray-700">Zu analysierender Text <span v-if="form.text.length > 0">({{ form.text.length }} Zeichen)</span></label>
                          <textarea id="text" v-model="form.text" :disabled="form.processing" rows="15"
                            class="mt-1 focus:ring-gray-400 focus:border-gray-400 block w-full sm:text-sm border-gray-300 rounded-md py-2"></textarea>
                        </div>


                      </div>


                    </div>
                  </div>
                </div>





                <div class="mt-8 border-t border-gray-200 pt-5">
                  <div class="flex justify-end">
                    <submit-button :sending="form.processing" :validated="validated"
                      :full-width="false">Generieren</submit-button>
                  </div>
                </div>
              </form>

            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import SubmitButton from '@/Shared/SubmitButton.vue';


export default {
  metaInfo: { title: 'Coyp Quick Check' },

  components: {
    Layout,
    HorizontalDivider,
    SubmitButton,
  },

  props: {

  },

  data() {
    return {
      jobId: null,
      form: this.$inertia.form({
        text: '',
      }),
    };
  },

  methods: {
    submit() {
      this.form.clearErrors();
      this.jobId = null;

      this.form.processing = true;

      const tokenTag = document.querySelector('meta[name="csrf-token"]');
      const csrfToken = tokenTag ? tokenTag.getAttribute('content') : null;

      window.axios.post(this.route('copy-quick-check.generate'), {
        text: this.form.text,
      }, {
        headers: csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {},
      }).then((response) => {
        this.jobId = response.data.id;
        if (response.data.redirect_url) {
          window.location.href = response.data.redirect_url;
        }
      }).catch((error) => {
        if (error.response && error.response.status === 422) {
          this.form.setError(error.response.data.errors || {});
        } else {
          // Use form error area for a simple failure message.
          this.form.setError({ text: 'Request fehlgeschlagen.' });
        }
        this.form.processing = false;
      });
    },
  },

  computed: {
    validated() {
      return (
        this.form.text.length
      );
    },


  },

};
</script>
